import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pp-ticket-check-results" }

import { computed, onMounted } from "vue";
import PpTicketCheckResultsSummary from "./pp-ticket-check-results-summary.vue";
import PpTicketCheckResultsDetail from "./pp-ticket-check-results-detail.vue";
import { usePpTicketCheck } from "../../composables/use-ticket-check";
import { ProductPageAnalytics } from "../../analytics/analytics-product-page";
import { usePpWagerConfiguration } from "../../composables/use-wager-configuration";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-ticket-check-results',
  setup(__props) {

const { ticketCheckResult } = usePpTicketCheck();
const { config } = usePpWagerConfiguration();

const analyticsResult = computed(() => (ticketCheckResult.value.winAmount > 0 ? "win" : "loss"));
ProductPageAnalytics.pushTicketCheckResult(analyticsResult.value, config.lottery);

onMounted(() => {
    const container = document.getElementById("pp-check-and-results");
    if (container) {
        container.style.display = "none";
    }
    const carousel = document.getElementById("pp-quick-wager-carousel");
    if (carousel) {
        carousel.style.display = "none";
    }

    document.body.classList.add("theme--ticket-check-results");

    window.scrollTo(0, 1);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "main" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PpTicketCheckResultsSummary),
      _createVNode(PpTicketCheckResultsDetail)
    ])
  ]))
}
}

})